import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatLegacyOptionSelectionChange as MatOptionSelectionChange } from '@angular/material/legacy-core';
import { TypedFormBuilder, TypedFormGroup } from '@gmrappdev/formsafe';
import {
  createPrdSeparationTypes,
  EmploymentRecordViewModel,
} from 'src/view-models/employment-record-view-model';
import { PrdProcessingState } from 'src/view-models/pilot-view-model';
import { PrdProcessingStateSelectItems } from '../pilot-form/pilot-form.component';

@Component({
  selector: 'fl-pilot-employment-record-form',
  templateUrl: './pilot-employment-record-form.component.html',
  styleUrls: ['./pilot-employment-record-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotEmploymentRecordFormComponent implements OnInit {
  @Input()
  public employmentRecord?: EmploymentRecordViewModel;
  @Input()
  public pilotId: string;
  public form: TypedFormGroup<EmploymentRecordViewModel>;
  public processingStateOptions = PrdProcessingStateSelectItems;
  private prdSeparationTypes = createPrdSeparationTypes();

  public separationTypeOptions = this.prdSeparationTypes.separationTypes;

  public minDate = new Date(1950, 0, 1);
  public maxDate = new Date(Date.now());

  constructor(private _tfb: TypedFormBuilder) {}

  public ngOnInit() {
    const employmentRecord: Partial<EmploymentRecordViewModel> =
      this.employmentRecord != null ? this.employmentRecord : {};
    this.form = this._tfb.group<EmploymentRecordViewModel>({
      id: [employmentRecord.id],
      completeDate: [employmentRecord.completeDate],
      finalRecordsDate: [employmentRecord.finalRecordsDate],
      lastProcessedDate: [employmentRecord.lastProcessedDate],
      pilotId: [employmentRecord.pilotId ?? this.pilotId],
      prdDateOfHire: [employmentRecord.prdDateOfHire, Validators.required],
      prdSourceSystemId: [employmentRecord.prdSourceSystemId],
      processingError: [employmentRecord.processingError],
      processingState: [
        employmentRecord.processingState ?? PrdProcessingState.ReadyForTransmission,
      ],
      relevantDocuments: [employmentRecord.relevantDocuments ?? false],
      separationDate: [employmentRecord.separationDate],
      separationType: [employmentRecord.separationType],
      separationTypeDetail: [employmentRecord.separationTypeDetail],
    });
  }

  public async onSeparationTypeChange(event: MatOptionSelectionChange) {
    if (event.source.selected) {
      const value = event.source.value;
      const ctrl = this.form.controls.separationTypeDetail;
      if (this.prdSeparationTypes.isOther(value)) {
        ctrl.setValidators([Validators.required, Validators.maxLength(500)]);
        ctrl.markAsTouched();
      } else {
        ctrl.reset();
        ctrl.clearValidators();
      }
      ctrl.updateValueAndValidity();
    }
  }
}
